import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { generateCoFounderInviteCode } from '@/store/services/userServices';
import Preloader from '@/components/UI/Preloader';
import { RoundButton } from '@/components/UI/RoundButton';
import Notify from '@/components/Notification';
import config from '@/config';
import './index.scss';

const CoFounderInvitation = () => {
  const [loading, setLoading] = useState(true);
  const [code, setCode] = useState('');
  const { t } = useTranslation('modal');

  useEffect(() => {
    generateCode();
  }, []);

  const generateCode = async () => {
    try {
      const res = await generateCoFounderInviteCode();
      res && res.success && setCode(res.data.code);
    } finally {
      setLoading(false);
    }
  };

  const link = code && `${config.baseURL}/sign-up/co-founder/${code}`;

  return (
    <div className="co-founder-invitation">
      {loading ? (
        <Preloader />
      ) : (
        <>
          <div className="f-32 f-500">
            {link
              ? t('co_founder_invite.invite_co_founders')
              : t('co_founder_invite.could_not_generate_link')}
          </div>
          {link && (
            <div className="co-founder-invitation__desc f-18 f-400">
              {t('co_founder_invite.invite_co_founders_desc')}
            </div>
          )}
          {link && <input type="text" value={link} readOnly className="f-16 f-400" />}
          <div className="co-founder-invitation__buttons">
            {code ? (
              <RoundButton
                label={t('co_founder_invite.copy_link')}
                fullWidth
                fillBackground
                className="co-founder-invitation__copy-btn"
                onClick={() =>
                  navigator &&
                  navigator.clipboard &&
                  navigator.clipboard.writeText(link).then(() => {
                    Notify.success({ text: t('co_founder_invite.link_copied') });
                  })
                }
              />
            ) : (
              <RoundButton
                label={t('co_founder_invite.generate_link')}
                onClick={() => {
                  setLoading(true);
                  generateCode();
                }}
              />
            )}
          </div>
        </>
      )}
    </div>
  );
};

export default CoFounderInvitation;
